import React from 'react';

import fetch from '../../fetch';

import utils from '../../../utils';

const prefixUrl = "eval/totalData/view/"

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

const columnsArray = [
    { type: 'selection' },
    {   
        key:'$index', 
        label: '序号',
        width: 80
    },
    {
        key: 'orgName',
        label: '所属部门',
        width: 100
    },
    {
        key:'employeeCode', 
        label: '教师工号',
        width: 100
    },
    {
        key: 'employeeName',
        label: '教师姓名',
        width: 100
    },
    {
        key: 'majorName', 
        label: '所属专业或教研室',
        width: 150
    },
    {
        key: 'workLoad', 
        label: '全学年教学工作量',
        width: 150
    },
    {
        key: 'evaluation', 
        label: '工作量是否符合评优条件',
        width: 150
    },
    {
        key: 'teachingAccident', 
        label: '是否发生教学事故',
        width: 150
    },
    {
        key: 'discipline', 
        label: '是否有其他违法违规违纪情况',
        width: 150
    },
    {
        key: 'entry', 
        label: '是否2022年9月后入职',
        width: 150
    },
    {
        key: 'orgScore', 
        label: '部门总分',
        width: 100
    },
    {
        key: 'orgGrade', 
        label: '部门等级',
        width: 100
    },
    {
        key: 'orgGradeDesc', 
        label: '部门等级描述',
        width: 150
    },
    {
        key: 'dudaoScore', 
        label: '督导总分',
        width: 100
    },
    {
        key: 'dudaoGrade', 
        label: '督导等级',
        width: 100
    },
    {
        key: 'dudaoGradeDesc', 
        label: '督导等级描述',
        width: 150
    },
    {
        key: 'stuScoreFirst', 
        label: '学生分数(第一学期)',
        width: 100
    },
    {
        key: 'stuScoreSecond', 
        label: '学生分数(第二学期)',
        width: 100
    },
    {
        key: 'stuScoreAll', 
        label: '学生总分',
        width: 100
    },
    {
        key: 'stuGrade', 
        label: '学生等级',
        width: 100
    },
    {
        key: 'stuGradeDesc', 
        label: '学生等级描述',
        width: 150
    },
    {
        key: 'finalScore', 
        label: '三方总分',
        width: 100
    },
    {
        key: 'finalGrade', 
        label: '三方等级',
        width: 100
    },
    {
        key: 'finalGradeDesc', 
        label: '三方等级描述',
        width: 150
    },
    {
        key: 'finalLevel', 
        label: '最终等级',
        width: 100
    },
    {
        key: 'finalLevelDesc', 
        label: '最终等级描述',
        width: 150
    },
    {
        key: 'resultDesc', 
        label: '备注',
        width: 100
    },
    {
        key: 'dataFrom', 
        label: '数据来源(是否来自部门提供名单)',
        width: 100
    },
    {
        key: 'organization', 
        label: '是否在编',
        width: 100,
        render: (data) => {
            if(data == 2){
                return '在编';
            } else if(data == 1){
                return '外聘';
            } else {
                return '未知状态';
            }
        }
    },
    {
        key: 'yearName', 
        label: '所属学年',
        width: 100
    }
]

const headers = utils.columns(
    [
        { type: 'selection' },
        {   
            key:'$index', 
            label: '序号',
            width: 80
        },
        {
            key: 'orgName',
            label: '所属部门',
            width: 100
        },
        {
            key:'employeeCode', 
            label: '教师工号',
            width: 100
        },
        {
            key: 'employeeName',
            label: '教师姓名',
            width: 100
        },
        {
            key: 'majorName', 
            label: '所属专业或教研室',
            width: 150
        },
        {
            key: 'workLoad', 
            label: '全学年教学工作量',
            width: 150
        },
        {
            key: 'evaluation', 
            label: '工作量是否符合评优条件',
            width: 150
        },
        {
            key: 'teachingAccident', 
            label: '是否发生教学事故',
            width: 150
        },
        {
            key: 'discipline', 
            label: '是否有其他违法违规违纪情况',
            width: 150
        },
        {
            key: 'entry', 
            label: '是否2022年9月后入职',
            width: 150
        },
        {
            key: 'orgScore', 
            label: '部门总分',
            width: 100
        },
        {
            key: 'orgGrade', 
            label: '部门等级',
            width: 100
        },
        {
            key: 'dudaoScore', 
            label: '督导总分',
            width: 100
        },
        {
            key: 'dudaoGrade', 
            label: '督导等级',
            width: 100
        },
        {
            key: 'stuScoreFirst', 
            label: '学生分数(第一学期)',
            width: 150
        },
        {
            key: 'stuScoreSecond', 
            label: '学生分数(第二学期)',
            width: 150
        },
        {
            key: 'stuScoreAll', 
            label: '学生总分',
            width: 100
        },
        {
            key: 'stuGrade', 
            label: '学生等级',
            width: 100
        },
        {
            key: 'finalScore', 
            label: '三方总分',
            width: 100
        },
        {
            key: 'finalGrade', 
            label: '三方等级',
            width: 100
        },
        {
            key: 'finalLevel', 
            label: '最终等级',
            width: 100
        },
        {
            key: 'resultDesc', 
            label: '备注',
            width: 100
        },
        {
            key: 'dataFrom', 
            label: '数据来源(是否来自部门提供名单)',
            width: 180
        },
        {
            key: 'organization', 
            label: '是否在编',
            width: 100,
            render: (data) => {
                if(data == 2){
                    return '在编';
                } else if(data == 1){
                    return '外聘';
                } else {
                    return '未知状态';
                }
            }
        },
        {
            key: 'yearName', 
            label: '所属学年',
            width: 100
        }
    ]
)

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    if(`${keywords.sort}` != 'undefined'){
        params.push(`sort=${keywords.sort}`)
        params.push(`order=${keywords.order}`)
    }
    return fetch.post(`${prefixUrl}query?` + params.join('&'), keywords)
    .then(response => {
        let extParams = response.payload.meta.extParams;
        let newArray = []
        
        if(extParams && extParams.organization == 1){
            for (let i = 0; i < columnsArray.length; i++) {
                if (columnsArray[i].key != 'evaluation' && columnsArray[i].key != 'entry') {
                    newArray.push(columnsArray[i])
                }
            }
        }
        if (response.code === 200) {
            return {
                data: response.payload.data,
                headers: utils.columns(newArray.length > 0 ? newArray : columnsArray)
            }
        }
    })
    .then(res => (
        Object.assign({
            headers: res.headers,
            result: res.data.dataList || [],
            selects: (res.data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
            })),
            checked: false,
            total: res.data.total,
            pageIndex: res.data.pageNum,
            pageSize: res.data.pageSize,
            notify: (res.data.dataList || []).length ? '' : '暂无数据...'
        }))
    )
}

const removeByIds = (ids) => {
    return fetch.post(`${prefixUrl}deleteByIds`, ids).then(response => {
        if(response.code == 200) {
            return response.payload.data;
        }
    })
}

const removeByQuery = (keywords) => {
    return fetch.post(`${prefixUrl}deleteByQuery`, keywords).then(response => {
        if(response.code == 200) {
            return response.payload.data;
        }
    })
}

const statTotalData = (keywords = {}) => {
    return fetch.post(`${prefixUrl}statTotalData`, keywords)
    .then((response) => {
       return response;
    })
}

const countGrade = (keywords = {}) => {
    return fetch.post(`${prefixUrl}countGrade`, keywords)
    .then((response) => {
        return response;
    })
}


export default {
    getSelection: () => DataGrid.selections,
    onSelect,
    setRefresh,
    querySearch,
    headers,
    removeByIds,
    removeByQuery,
    statTotalData,
    countGrade
}